import { useState } from 'react';
import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import { cloneConfluenceArticle } from '../api';
import { Confluence } from '../interfaces';

function useCloneArticle(article: Confluence.IArticle | null, onClone?: (cloneId: number) => void) {
  const [{ error, loading }, setData] = useState<{
    loading: boolean;
    error: boolean;
  }>({ loading: false, error: false });

  const { enqueueSnackbar } = useSnackbar();

  async function handleCloneArticle(name: string, parentId?: number, section?: Confluence.ESections) {
    if (!article?.id) return;

    try {
      setData((prevState) => ({ ...prevState, loading: true }));

      const cloneId = await cloneConfluenceArticle(article.id, { name, parentId: parentId ?? null, section });

      enqueueSnackbar('Статья успешно клонирована', { variant: 'success' });
      if (onClone) onClone(cloneId);
    } catch (error) {
      setData({ loading: false, error: true });
      enqueueSnackbar((error as AxiosError).response?.data.message, { variant: 'error' });
    } finally {
      setData((prevState) => ({ ...prevState, loading: false }));
    }
  }

  return { loading, error, handleCloneArticle };
}

export default useCloneArticle;
